var shared = require('../internals/shared');

module.exports = shared('native-function-to-string', Function.toString);



//////////////////
// WEBPACK FOOTER
// ./node_modules/irc-framework/node_modules/core-js/internals/function-to-string.js
// module id = pDXZ
// module chunks = 0